import React, { useState } from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import { required } from 'Utils/Validators/formValidation'

import Form from 'Components/Form'
import { Col, Row } from 'react-bootstrap'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { Textarea } from 'Components/Form/Textarea'
import Card from '@material-ui/core/Card'

import { DOCUMENT_FORM } from '../constants'

import { styles } from '../styles'
import GenericFlatButton from '../../../../Components/GenericFlatButton'
import GenericSubmitButton from '../../../../Components/Form/GenericSubmitButton'
import InfoCard from '../../../../Components/InfoCard'
import CitySelectPanel from '../../../../Components/Form/CitySelectPanel'

const DocumentForm = ({
  classes,
  submitHandler,
  mode,
  documentType,
  сountryCodeSelectOptions,
  redirectToDocumentationList,
  cities,
  setContextData,
  allCities,
  countryCode,
}) => {
  const [active, setActive] = useState(documentType.active)

  return (
    <Form onSubmit={submitHandler}>
      <Card className={classes.card}>
        <Row className={classes.row}>
          <Col xs={12}>
            <InfoCard
              title={`Both the 'name' and 'instruction' information are shown in the app.`}
            />
          </Col>
        </Row>
        <Row className={classes.row}>
          <Col xs={mode === DOCUMENT_FORM.CREATE ? 6 : 4}>
            <Input
              label="Name"
              name="name"
              placeholder="Type of ID such as Drivers License or Passport"
              validator={[required]}
              initValue={documentType.name}
            />
          </Col>
          <Col xs={mode === DOCUMENT_FORM.CREATE ? 6 : 4}>
            <SelectDashboard
              name="countrycode"
              label="Country code"
              options={сountryCodeSelectOptions}
              initValue={
                Object.keys(documentType).length && documentType.countryCode
                  ? documentType.countryCode
                  : countryCode
              }
              validator={[required]}
            />
          </Col>
          {mode === DOCUMENT_FORM.EDIT && (
            <Col xs={4}>
              <SelectDashboard
                name="active"
                label="Status"
                initValue={documentType.active.toString()}
                options={[
                  { label: 'Active', value: 'true' },
                  { label: 'Inactive', value: 'false' },
                ]}
                value={active.toString()}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={12}>
            <CitySelectPanel
              cities={cities}
              name={'citiesList'}
              setContextData={setContextData}
              allCities={allCities}
              documentType={documentType}
              mode={mode}
              setActive={setActive}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Textarea
              name="instructiontext"
              label="Instruction"
              placeholder="Instructions required by a new BA when taking photos of this specific document"
              initValue={documentType.instructionText}
              validator={[required]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={classes.buttonsWrapper}>
              <GenericFlatButton
                type={'outline'}
                title={'Cancel'}
                onClick={redirectToDocumentationList}
              />

              <GenericSubmitButton />
            </div>
          </Col>
        </Row>
      </Card>
    </Form>
  )
}

export default withStyles(styles)(DocumentForm)
